import {
    Flex,
    Button,
    Select,
    Input,
    FormControl,
    FormLabel,
    Icon,
    Grid,
    FormHelperText,
    Box,
    Text,
    useColorMode,
    useColorModeValue,
    Image,
    Link
} from "@chakra-ui/react";
import { HSeparator } from "components/Separator/Separator";
import React, { useEffect, useState, useCallback } from "react";
import {
    GiChocolateBar,
} from "react-icons/gi";
import ReactSelect from 'react-select/creatable'
import { useDropzone } from 'react-dropzone';
import uploadFile from "api/filemanager/upload-file";
import { toast } from 'react-toastify';
import config from "config/index";

export function PopupGallery(props) {
    const { files, popups, popupInput, setPopupInput } = props
    const [, updateState] = useState();
    const [options,setOptions] = useState([]);
    const [uploadingIndex, setUploadingIndex] = useState(null);
    const forceUpdate = useCallback(() => updateState({}), []);
    const { colorMode } = useColorMode();

    // تابع برای تبدیل مسیر فایل به URL
    const getFileUrl = (filePath) => {
        if (!filePath) return null;
        const url = filePath.replace("upload/user/", "assets/users/");
        return `${config.host}/${url}`;
    };

    const handleChanges = (event, index) => {
        setPopupInput(prev => {
            let data = {...prev};
            if (!data.gallery)
                data.gallery = []
            data.gallery = [...data.gallery]
            if (!data.gallery[index])
                data.gallery[index] = {}
            
            data.gallery[index] = {
                ...data.gallery[index],
                [event.target.name]: event.target.value
            }
            return data;
        })
    }
    const handleSelectChanges = (event, index,name) => {
        console.log(name)
        console.log(index)
        console.log(event.value)
        setPopupInput(prev => {
            let data = {...prev};
            if (!data.gallery)
                data.gallery = []
            data.gallery = [...data.gallery]
            if (!data.gallery[index])
                data.gallery[index] = {}
            
            data.gallery[index] = {
                ...data.gallery[index],
                [name]: event.value
            }
            console.log(data)
            return data;
        })
    }
    function removeFields(index) {
        setPopupInput(prev => {
            let data = {...prev};
            if (!data.gallery)
                data.gallery = []
            data.gallery = [...data.gallery]
            data.gallery.splice(index, 1)
            return data;
        })
        forceUpdate()
    }
    function addField() {
        setPopupInput(prev => {
            let data = {...prev};
            if (!data.gallery)
                data.gallery = []
            data.gallery = [...data.gallery, {
                href: "",
            }]
            return data;
        })
        forceUpdate()
    }

    const handleImageUpload = useCallback((acceptedFiles, index) => {
        if (acceptedFiles.length === 0) return;
        
        const file = acceptedFiles[0];
        setUploadingIndex(index);
        
        const progressCallback = (percent) => {
            // می‌توانید progress را نمایش دهید
        };

        uploadFile(file, progressCallback)
            .then((result) => {
                const filePath = result?.data?.path || result?.path || result?.data?.file?.path;
                if (filePath) {
                    setPopupInput(prev => {
                        let data = {...prev};
                        if (!data.gallery)
                            data.gallery = []
                        if (!data.gallery[index])
                            data.gallery[index] = {}
                        data.gallery[index].href = filePath;
                        return data;
                    });
                    toast.success("فایل تصویر با موفقیت آپلود شد", {
                        position: "bottom-right"
                    });
                } else {
                    console.log("Response format:", result);
                    toast.error("خطا در دریافت مسیر فایل", {
                        position: "bottom-right"
                    });
                }
            })
            .catch((err) => {
                console.error(err);
                if (err?.response?.data?.message?.pr) {
                    toast.error(err.response.data.message.pr, {
                        position: "bottom-right"
                    });
                } else {
                    toast.error("خطا در آپلود فایل تصویر", {
                        position: "bottom-right"
                    });
                }
            })
            .finally(() => {
                setUploadingIndex(null);
            });
    }, [setPopupInput]);

    const ImageUploadDropzoneComponent = ({ index, value, uploading, onUpload }) => {
        const dropzone = useDropzone({
            onDrop: (acceptedFiles) => onUpload(acceptedFiles, index),
            accept: {
                'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp']
            },
            maxFiles: 1,
            multiple: false,
            disabled: uploading
        });

        const fileUrl = value ? getFileUrl(value) : null;
        const border = useColorModeValue("#E2E8F0", " rgba(255, 255, 255, 0.24)");

        return (
            <Box>
                <Box
                    {...dropzone.getRootProps()}
                    border="2px dashed"
                    borderColor={dropzone.isDragActive ? "blue.400" : "gray.300"}
                    borderRadius="md"
                    p="20px"
                    textAlign="center"
                    cursor={uploading ? "not-allowed" : "pointer"}
                    bg={dropzone.isDragActive ? "blue.50" : "transparent"}
                    opacity={uploading ? 0.6 : 1}
                    transition="all 0.2s"
                    _hover={!uploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
                >
                    <input {...dropzone.getInputProps()} />
                    {uploading ? (
                        <Text fontSize="xs" color="blue.500">
                            در حال آپلود...
                        </Text>
                    ) : value ? (
                        <Text fontSize="xs" color="green.500">
                            فایل انتخاب شده: {value.split('/').pop()}
                        </Text>
                    ) : (
                        <Text fontSize="xs" color="gray.500">
                            {dropzone.isDragActive
                                ? "فایل را اینجا رها کنید"
                                : "فایل تصویر را اینجا بکشید یا کلیک کنید"}
                        </Text>
                    )}
                </Box>
                {fileUrl && !uploading && (
                    <Box mt="15px" textAlign="center">
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Image 
                                src={fileUrl} 
                                alt="تصویر انتخاب شده" 
                                maxH="200px" 
                                maxW="100%"
                                borderRadius="md"
                                border="1px solid"
                                borderColor={border}
                            />
                        </Box>
                        <Link href={fileUrl} target="_blank" fontSize="xs" color="blue.500" mt="10px" display="block">
                            مشاهده تصویر در تب جدید
                        </Link>
                    </Box>
                )}
            </Box>
        );
    };
    const iconBlue = useColorModeValue("gray.100", "gray.600");
    const textColor = useColorModeValue("gray.700", "white");

    const border = useColorModeValue("#E2E8F0", " rgba(255, 255, 255, 0.24)");
    const colourStyles = {
        control: (styles) => { return ({ ...styles, backgroundColor: iconBlue, borderColor: border, "font-size": "12px" }) },
        option: (styles, { data, isSelected }) => {
            if (data.value == "new")
                return ({ ...styles, textAlign: "center", color: "#485ea1", "font-size": "12px" })
            else if (isSelected)
                return ({ ...styles, backgroundColor: "#C3D0BF", color: "black", "font-size": "12px" })
            else
                return ({ ...styles, color: "black", "font-size": "12px" })
        },
        singleValue: (styles) => ({ ...styles, color: textColor }),
        placeholder: (styles) => ({ ...styles, color: textColor }),
        input: (styles) => ({ ...styles, color: textColor }),
    };
    useEffect(()=>{
        let list = files.filter((item) => (item.ext == "png" || item.ext == "jpg") || item.ext == "jpeg").map((row, idx) => {
            let image="https://tpan.ir/"+row.path.replace("upload/user","assets/users/thumbnail/")
            console.log(image)
            return {
                value: row.path,
                label: row.filename,
                image:image
            }
        })
        setOptions(list.reverse())
    },[files])

        
    
    return (
        <Grid>
            {popupInput && popupInput?.gallery?.map((input, index) => {
                return (
                    <div key={index} >
                        {(index != 0) ?
                            (
                                <HSeparator mt={"35px"} bg={colorMode === "dark" ? "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #303742 49.52%, rgba(224, 225, 226, 0) 100%)" : "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #eee 49.52%, rgba(224, 225, 226, 0) 100%)"}></HSeparator>
                            ) : <></>
                        }
                        <Grid mt={"30px"}>
                            <Flex>
                                <FormControl w='100%' id="image-files-input">
                                    <FormLabel fontSize={"xs"} >فایل تصویر {"#" + (index + 1)}</FormLabel>
                                    <ImageUploadDropzoneComponent 
                                        index={index}
                                        value={input.href}
                                        uploading={uploadingIndex === index}
                                        onUpload={handleImageUpload}
                                    />
                                </FormControl>
                            </Flex>
                            <Flex mt={"20px"}>
                                <FormControl w='100%' id="caption">
                                    <FormLabel fontSize="xs" >کپشن {"#" + (index + 1)}</FormLabel>
                                    <Input value={input.caption} name='caption' fontSize="xs" placeholder="عنوان را وارد کنید." onChange={event => handleChanges(event, index)} />
                                </FormControl>
                            </Flex>
                            <Flex mt={"20px"}>
                                <Button mt={"10px"} fontSize='xs' onClick={() => removeFields(index)} >حذف رکورد</Button>
                            </Flex>
                        </Grid>

                    </div>
                )
            })}
            <Flex mt={"20px"}>
                <Button mt={"10px"} w={"100%"} fontSize='xs' onClick={() => addField()} >افزودن رکورد</Button>
            </Flex>
        </Grid>
    )
}